import React from "react";
import { useState } from "react";
import axios from "axios";
import "./loginregister.css";
import Image1 from "../../assets/images/login_page_img_two.png";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../../Constants";
function Login() {
  
  const [inputFields, setInputfields] = useState({
    username: "",
    password: "",
  });
  const navigation = useNavigate();

  const [errors, setErrors] = useState({});

  const validaterrors = (inputvalues) => {
    let errors = {};
    if (inputvalues.username == "") {
      errors.username = "Mobile Number or Email ID is required";
    }
    if (inputvalues.password == "") {
      errors.password = "Password is required";
    } else if (inputFields.password.length < 6) {
      errors.password = "Password must be 6 characters";
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationerrors = validaterrors(inputFields);
    setErrors(validationerrors);

    if (Object.keys(validationerrors).length == 0) {
      const logindata = async () => {
        try {
          const response = await axios.post(apiurl + "login", {
            user_name: inputFields.username,
            password: inputFields.password,
          });

          const data = response.data;
          if (response.status === 200 && data.success) {
            localStorage.setItem("userId", data.user.id);
            localStorage.setItem("userName", data.user.user_name);
            localStorage.setItem("email", data.user.email);
            localStorage.setItem("phone_number", data.user.phone);

            toast.success("✓", { autoClose: 2000, className: "custom-toast" });
            navigation("/");
          } else {
            console.error("Login failed:", data.message);

            toast.error("✖", { autoClose: 2000, className: "custom-toast" });
          }
        } catch (error) {
          console.error("Error during login:", error);
          toast.error(
            error.response?.data?.message || "An unexpected error occurred.",
            { autoClose: 2000 }
          );
        }
      };
      logindata();
    }
  };

  const handlechange = (e) => {
    setInputfields({ ...inputFields, [e.target.name]: e.target.value });
  };


  

  return (
    <section className="loginregister_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12"></div>
          <div className="col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <h2 className="text-center">Login</h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    Mobile Number or Email ID{" "}
                    <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    value={inputFields.username}
                    onChange={handlechange}
                    placeholder="Mobile Number or Email ID"
                  />
                  {errors.username ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.username}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    Password <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    value={inputFields.password}
                    onChange={handlechange}
                    placeholder="Password"
                  />
                  {errors.password ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.password}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3 text-center">
                  <button className="btn_1_1 " type="submit">
                    Submit
                  </button>
                </div>
              </form>
              <p className="text-center">
                If you don't have Account{" "}
                <Link
                  to="/register"
                  style={{ color: "#76a70e", textDecoration: "none" }}
                >
                  Register
                </Link>
              </p>
              <p className="text-center mb-0">
                {" "}
                <Link
                  to="/forgot_password"
                  style={{ color: "#76a70e", textDecoration: "none" }}
                >
                  Forgot Password
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
